import React from "react";
import { format } from "date-fns";
import { Link } from "@quintype/components";

import { StoryCard } from "../../story-elements";

import "./key-events.m.css";
import findIndex from "lodash/findIndex";

const getEvents = (cards = []) => {
  return cards.map((card) => {
    const titleElement = card["story-elements"].find(({ type }) => type === "title");

    if (titleElement) {
      return {
        ...titleElement,
        "card-id": card.id,
        "card-added-at": card["card-added-at"]
      };
    }
  });
};

const TimeStamp = ({ card }) => {
  const time = format(card["card-added-at"], "kk:mm");
  const date = format(card["card-added-at"], "dd MMM yyyy");

  return (
    <div styleName="event-date">
      <span>{time}</span>
      <span>{date}</span>
    </div>
  );
};
const handleScroll = (element) => {
  if (typeof window !== "undefined") {
    // document.getElementById("card" + element.id).scrollIntoView({
    //   behavior: "smooth",
    //   block: "start",
    //   inline: "nearest",
    // });
    var element = document.getElementById("card" + element.id);
    const headerOffset = 45;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - 100;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }
};
const KeyEvents = ({ story }) => {
  const events = getEvents(story.cards);

  if (!events.length) return null;
  const withKeyEvents = story.cards.filter(
    (card) => card?.metadata?.attributes["key-event"] && card?.metadata?.attributes["key-event"] == true
  );
  return (
    <div styleName="wrapper">
      {withKeyEvents.length && story["owner-name"] !== "Migrator" ? (
        <>
          <div styleName="title">ಪ್ರಮುಖ ಘಟನೆಗಳು</div>
          <div styleName="events-timeline">
            {withKeyEvents?.map((card, idx) => (
              <div styleName="event-item" key={idx}>
                <TimeStamp card={card} />
                <div
                  onClick={() => handleScroll(card)}
                  style={{ position: "relative", bottom: "2px", cursor: "pointer" }}
                >
                  <StoryCard
                    card={{
                      ...card,
                      "story-elements": card["story-elements"].filter((el) => el.type === "title")
                    }}
                    story={story}
                    key={idx}
                  />
                </div>
              </div>
            ))}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default KeyEvents;
